import moment from "moment";
import React from "react";
import { Row, Col, Card, ListGroup, Button } from "react-bootstrap";

const InstructionSetCard = ({ instruction_set_details }) => {
  const hasData = instruction_set_details?.[0]
    ? Object?.keys(instruction_set_details?.[0])?.length
    : 0;

  return (
    <Card
      style={{ border: "1px solid #ddd", marginLeft: "5px" }}
      className=" border border-primary"
    >
      <Card.Header
        style={{ fontWeight: "bold" }}
        className="bg-primary text-white"
      >
        Instruction Set
      </Card.Header>
      {hasData ? (
        <Card.Body>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  <strong>Payment</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  : {instruction_set_details?.[0]?.payment}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  <strong>Next Debit Date</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  :{" "}
                  {moment(instruction_set_details?.[0]?.next_debit_date).format(
                    "MM/DD/yyyy"
                  )}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  <strong>Debit Amount</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  : {instruction_set_details?.[0]?.debit_amount}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          {/* <Button
            variant="link"
            style={{
              textDecoration: "none",
              color: "#007bff",
              padding: 0,
              marginTop: "1rem",
            }}
          >
            Set Payment Preference
          </Button> */}
        </Card.Body>
      ) : (
        <Card.Text className="p-4">
          <span>No Instruction Set </span>
        </Card.Text>
      )}
      {/* <Row>
        <Col>
          <div className="d-flex justify-content-center">
            <div className="text-center">
              <span
                style={{
                  letterSpacing: "3px",
                  fontSize: "1.2rem",
                  color: "#6c757d",
                }}
              >
                •••
              </span>
            </div>
          </div>
        </Col>
      </Row> */}
    </Card>
  );
};

export default InstructionSetCard;
